module.exports = __webpack_public_path__ + "static/media/cart.a72969d9.svg";